import React, { Component } from "react";
import "./AWSToggleButton.scss";
import { Toggle } from "@amzn/awsui-components-react";
import * as roleNames from '../../../constants/roleNames.const';
import * as dealStatusConstant from '../../../constants/dealStatusConstant';
import * as tagNameConstant from '../../../constants/tagNameConstant';
import { userRoleCheckForEditableCell } from "../../../utils/common";

export default class AWSToggleButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleState: 'No'
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value === null && this.props.defaultValue) {
      this.props.onChange(this.props.defaultValue);
    } else if (prevProps.value !== this.props.value) {
      this.props.onChange(this.props.value);
    }
  }

  componentDidMount() {
    let { questionValue, defaultValue, label } = this.props;

    if (this.props.value !== null) {
      this.props.onChange(this.props.value);
    } else if (defaultValue && (defaultValue === "Yes" || defaultValue === "No")) {
      this.props.onChange(defaultValue);
    }
  }

  getValue() {
    const { quePermission, value, defaultValue } = this.props;
    // this.setState({ toggleState: value });
    if (quePermission && (quePermission.read === false || quePermission.read === true)) {
      if (value) {
        switch (value) {
          case 'No':
            return false;
          case 'Yes':
            return true;
        }
      } else if (defaultValue) {
        switch (defaultValue) {
          case 'No':
            return false;
          case 'Yes':
            return true;
        }
      }
    } else if (quePermission === undefined) {
      if (value) {
        switch (value) {
          case 'No':
            return false;
          case 'Yes':
            return true;
        }
      } else if (defaultValue) {
        switch (defaultValue) {
          case 'No':
            return false;
          case 'Yes':
            return true;
        }
      }
    }
  }

  setToggleStateAndProps = () => {
    if (this.getValue() === true) {
      this.props.onChange('No');
      this.setState({ toggleState: 'No' });
    } else {
      this.props.onChange('Yes');
      this.setState({ toggleState: 'Yes' });
    }
  }

  onToggleChange = e => {
    const { quePermission, canEditPPR, dealStatus, userRole } = this.props;

    if (this.verifyDisablecondtionBasedOnstatus()) {
      this.setToggleStateAndProps()
    } else {
      if (canEditPPR === true) {
        if (quePermission && quePermission.read === false) {
          this.setToggleStateAndProps()
        } else if (quePermission === undefined) {
          this.setToggleStateAndProps()
        }
      }
    }
  }


  /**
  * this function will verify and return boolean for disable state of field based on status, userRole and question tagname
  */
  verifyDisablecondtionBasedOnstatus = () => {
    const { dealStatus, questionValue,locationStateUser, userRole, dealInfo } = this.props;
    const listOfQuestionBasedOnTagName = [tagNameConstant.autoRenewTag, tagNameConstant.isYourTag];
    if ((dealStatus === dealStatusConstant.Open_For_Review && userRoleCheckForEditableCell(locationStateUser, userRole, dealInfo, roleNames)) || userRole === roleNames.BILLING_TEAM) {
      if (questionValue && questionValue.tagName &&listOfQuestionBasedOnTagName.includes(questionValue.tagName)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  checkForDisable = (questionValue, canEditPPR) => {
    if (this.verifyDisablecondtionBasedOnstatus()) {
      return false
    } else {
      if (canEditPPR === true) {
          return questionValue && questionValue.quePermission && questionValue.quePermission.read ? questionValue.quePermission.read : false
      } else if (canEditPPR === false) {
        return true // disable true
      } else {
          return false
      }
    }
  }

  render() {
    const { toggleState } = this.state;
    const { questionValue, canEditPPR, defaultValue, userRole } = this.props;

    return (
      <div className="switch-wraper">
        <Toggle checked={this.getValue()} disabled={this.checkForDisable(questionValue, canEditPPR)} onChange={this.onToggleChange}>{this.getValue() === true ? "Yes" : "No"}</Toggle>
      </div>
    );
  }
}
